
import React, { useState, useMemo } from 'react';
import { fetcher } from 'api/client';
import { contractTypes, deleteContractType, updateContractType, createContractType } from 'api/actions/tenant';
import { toast } from 'components/Shared/Toast';
import { useTranslation } from 'react-i18next';
import bootbox from 'components/Modals/Bootbox';
import { useQuery, useQueryClient, useMutation } from 'react-query';
import ReactTable from 'components/Shared/ReactTable';
import { Button } from 'reactstrap';

function ContractTypesContainer() {

    const { t } = useTranslation();

    const queryClient = useQueryClient();
    // ACTIONS
    const onError = ({ message = 'GeneralError' } = {}) => {
        toast.error(t(`errors.${message}`))
    }

    const onSuccess = (invalidate = true) => {
        toast.success(t('success'))
        if (invalidate) queryClient.invalidateQueries('contract-types');
    }

    const { data: { options = [] } = {}, isSuccess } = useQuery('contract-types', () => fetcher(contractTypes()));
    const { mutate: mutateCreateType } = useMutation((data) =>
        fetcher(createContractType(data),), { onError, onSuccess });

    const { mutate: mutateDeleteType } = useMutation((typeId) =>
        fetcher(deleteContractType(typeId),), { onError, onSuccess });

    const { mutate: mutateUpdateType } = useMutation(({ _id, data }) =>
        fetcher(updateContractType(_id, data),), { onError, onSuccess });

    const columns = useMemo(() => [
        {
            Header: t('profile.contracttypes.title'),
            columns: [
                {
                    Header: t('profile.contracttypes.type'),
                    accessor: 'name',
                    type: 'input'
                },
                {
                    Header: t('profile.contracttypes.new_modal_jurisdiction'),
                    accessor: 'jurisdiction',
                    type: 'select',
                    options: [
                        { value: 'mx', label: t('editor.config.mx') },
                        { value: 'us', label: t('editor.config.us') },
                        { value: 'br', label: t('editor.config.br') },
                        { value: 'pr', label: t('editor.config.pr') },
                        { value: 'at', label: t('editor.config.at') },
                        { value: 'co', label: t('editor.config.co') },
                    ],
                    defaultOption: 'mx'
                }
            ],
        }
    ], [t]);

    // STATES
    const initialState = Object.freeze(columns[0].columns.reduce((acc, cur) => ({ ...acc, [cur.accessor]: cur.defaultOption || '' }), {}));
    const [showCreate, setshowCreate] = useState(false);
    const [newData, setnewData] = useState(initialState);

    // HANDLERS
    const handleUpdate = async (typeId, columnId, value) => {
        mutateUpdateType({ _id: typeId, data: { [columnId]: value } });
    }

    const handleDelete = async (typeId) => {
        const confirm = await bootbox.confirm(t('profile.contracttypes.confirm_delete'));
        if (confirm) mutateDeleteType(typeId);
    }

    const handleCreate = async () => {
        if (!newData.name) return toast.error(t('errors.MissingTypeName'));
        mutateCreateType(newData);
        setnewData(initialState);
    }

    return (
        <div className="profile-users">
            <h5>
                <i className="fas fa-file"></i> {t('profile.contracttypes.title')}
            </h5>
            <p>
                {t('profile.contracttypes.add')}
                {!showCreate && <Button className="float-right text-primary" size="sm" color="default" onClick={() => setshowCreate(true)} > <i className="fas fa-plus"></i> {t('profile.contracttypes.addnew')}</Button>}
            </p>
            {isSuccess &&
                <ReactTable
                    className="reportTable"
                    columns={columns}
                    data={options}
                    handleUpdate={handleUpdate}
                    setnewData={setnewData}
                    handleDelete={handleDelete}
                    handleCreate={handleCreate}
                    newData={newData}
                    showCreate={showCreate}
                    setshowCreate={setshowCreate}
                    key="contractTypeTable"
                />
            }
        </div>
    )
}

export default ContractTypesContainer;